import {
    Diferenciais,
    Produto,
    Coordenadas
} from '../../lib/model';

export class ResultadoPesquisa
{
    id: number;
    registroANS: string;
    operadoraRazaoSocial: string;
    nome: string;
    CRO: string;
    endereco: string;
    areaAtuacao: string;
    especialidades: string;
    telefones: string;
    localAtendimento: string;
    horarioAtendimento: string;
    tipoEstabelecimento: string;
    site: string;
    razaoSocial: string;
    CNPJ: string;
    observacao: string;
    diferenciais: Diferenciais
    produtos: Array<Produto>;
    Coordenadas: Coordenadas;

    constructor() 
    {
        this.diferenciais = new Diferenciais();
        this.produtos = new Array<Produto>();
        this.Coordenadas = new Coordenadas();
    }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/pesquisa/resultado-pesquisa/resultado-pesquisa.ts
 **/